<template>
  <div class="series-list-item-thumbnail">
    <StackIcon
      :name="itemStackIcon"
      color="#fff"
      background="light"
      size="67"
      borderRadius="24"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import StackIcon from '@/stack/components/stack-icon';

export default defineComponent({
  name: 'SeriesListItemThumbnail',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    itemStackIcon() {
      if (this.item.stacks) {
        return this.item.stacks[0].name;
      }

      return null;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    StackIcon,
  },
});
</script>

<style scoped>
@import './styles/series-list-item-thumbnail.css';
</style>
